import script from "./step_disputes.vue?vue&type=script&setup=true&lang=js"
export * from "./step_disputes.vue?vue&type=script&setup=true&lang=js"

import "./step_disputes.vue?vue&type=style&index=0&id=5dad7fd4&lang=css"

const __exports__ = script;

export default __exports__